// NOTE: NSAI-4692 — the floor a one-time ("at") schedule must sit ahead of, so
// the runner can still pick it up. Shared so web and mobile reject the same
// instants.
export const MIN_ONE_TIME_SCHEDULE_AHEAD_MINUTES = 5;

export const MIN_ONE_TIME_SCHEDULE_AHEAD_MS =
  MIN_ONE_TIME_SCHEDULE_AHEAD_MINUTES * 60 * 1000;

// NOTE: The "Once at" field carries a local wall clock ("YYYY-MM-DDTHH:mm"),
// the shape web's `datetime-local` input produces — not a UTC ISO string.
export const LOCAL_DATE_TIME_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;

export const ONE_TIME_SCHEDULE_INVALID_ERROR = "INVALID_ONE_TIME_SCHEDULE";

// NOTE: NSAI-4795 — the shape the friendly presets' Time field has to hold, with
// cron's own ranges baked into the pattern: hours 00-23, minutes 00-59. A pattern
// rather than a range check on the parsed parts, because the clients compile this
// field with `split(":")` + `Number()` — "09:0099" reaches that code as the
// perfectly well-formed cron `99 9 * * *`, and only the text can tell you it was
// never a time.
export const TIME_OF_DAY_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

// NOTE: NSAI-4795 — the presets whose cron expression is compiled FROM the Time
// field, so exactly the ones whose time has to be validated. Plain strings
// because mobile spells these as an enum and web as `as const` constants, both
// over the same i18n keys, and the check has to serve both.
export const TIME_OF_DAY_SCHEDULE_PRESETS = [
  "dailyAt",
  "weekdaysAt",
  "weeklyOn",
] as const;
